import type { ReactNode } from "react";

import { LoginPane } from "@contents/login-pane";
import { ReauthPane } from "@contents/reauth-pane";
import { useAuthStore } from "@entities/user-tokens";

/**
 * 認証状態に応じて表示を切り替えるルートコンポーネント。
 *
 * - initializing: taskpane.tsx の bootstrap 中。読み込み中を出す
 * - unauthenticated: LoginPane のみ表示
 * - authenticated: `content`（taskpane が ?view で選んだ業務ペイン）を表示
 * - reauth-required: `content` の上に ReauthPane (オーバーレイ) を重ねる
 */
export function AuthGate({ content }: { content: ReactNode }) {
    const status = useAuthStore((s) => s.status);

    switch (status) {
        case "initializing":
            // **何も描かないと白い画面になる。** bootstrap は描く前に認証の状態を決めるので
            // 通常ここは通らないが、通ったときに手がかりの無い画面を出さない（記録 37）。
            return <p className="p-3 text-sm text-text-muted">読み込み中...</p>;
        case "unauthenticated":
            return <LoginPane />;
        case "authenticated":
            return <>{content}</>;
        case "reauth-required":
            return (
                <>
                    {content}
                    <ReauthPane />
                </>
            );
    }
}
